import { render, staticRenderFns } from "./organiser_dialog.vue?vue&type=template&id=0bb17314&scoped=true"
import script from "./organiser_dialog.vue?vue&type=script&lang=js"
export * from "./organiser_dialog.vue?vue&type=script&lang=js"
import style0 from "./organiser_dialog.vue?vue&type=style&index=0&id=0bb17314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb17314",
  null
  
)

export default component.exports